// extracted by css-extract-rspack-plugin
export default {"banner-preview-tip":"PreviewTip-module__banner-preview-tip--EOsEg","bannerPreviewTip":"PreviewTip-module__banner-preview-tip--EOsEg"};